import { WrapMain } from '../../../../shared/modules/wrap_main'
import { useLocation } from 'react-router-dom';
import { selectMainState, useSelector } from "src/stateManagement/redux";
import { WellFileComponenet } from 'src/tecnica/modules/well_files';

export const UploadWellFiles = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');

    const { configModules } = useSelector(selectMainState);
    

    return (
        <WrapMain>
            {id &&  <WellFileComponenet id={id}/>}           
        </WrapMain>
    )
}
